// Passo veloce del checkout (devops #374): validazione, payload e lettura delle risposte di
// POST /api/auth/checkout-signup (contratto: docs/checkout-veloce.md in api#317). Logica pura, provata senza browser.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const ITALIAN_TAX_CODE_RE = /^[A-Z0-9]{16}$/;

export function normalizeTaxCode(v) {
    return String(v || '').replace(/\s+/g, '').toUpperCase();
}

/** Primo errore da mostrare, oppure null. Il server rifà ogni controllo: qui si evita solo un giro a vuoto. */
export function validateQuickSignup(form) {
    if (String(form?.firstName || '').trim().length < 2) return 'Inserisci il nome (almeno 2 caratteri).';
    if (String(form?.lastName || '').trim().length < 2) return 'Inserisci il cognome (almeno 2 caratteri).';
    if (!EMAIL_RE.test(String(form?.email || '').trim())) return 'Inserisci un indirizzo e-mail valido.';
    const cf = normalizeTaxCode(form?.taxCode);
    if (!cf) return 'Inserisci il codice fiscale.';
    if (form?.foreignTaxCode) {
        if (!form.gender) return 'Seleziona il genere.';
        if (!form.dateOfBirth) return 'Inserisci la data di nascita.';
    } else if (!ITALIAN_TAX_CODE_RE.test(cf)) {
        return 'Il codice fiscale deve contenere 16 caratteri.';
    }
    if (form?.acceptedTerms !== true) return 'Accetta i termini per continuare.';
    return null;
}

/** Corpo della richiesta (il contratto non prevede referral né altri campi). Data e genere si mandano solo per un codice estero: per quelli italiani li ricava il server. */
export function buildQuickSignupPayload(form) {
    const payload = {
        email: String(form.email).trim().toLowerCase(),
        firstName: String(form.firstName).trim(),
        lastName: String(form.lastName).trim(),
        taxCode: normalizeTaxCode(form.taxCode),
        acceptedTerms: form.acceptedTerms === true,
    };
    if (form.foreignTaxCode) {
        payload.gender = form.gender;
        payload.dateOfBirth = form.dateOfBirth;
    }
    return payload;
}

/**
 * Esito di una risposta: `ok` con la sessione, oppure `kind` + messaggio per l'utente.
 * `kind` serve alla UI: `exists` (porta al login), `minor` (porta alla registrazione completa),
 * `disabled` (flusso spento lato server: si ricade sul checkout di sempre).
 */
export function interpretSignupResponse(httpStatus, body) {
    const status = body?.status;
    if ((httpStatus === 200 || httpStatus === 201) && status === 'success' && body.token) {
        return { ok: true, token: body.token, expiresIn: body.expiresIn, userId: body.userId };
    }
    if (httpStatus === 404) return { ok: false, kind: 'disabled', message: 'Il checkout veloce non è disponibile: usa la registrazione completa.' };
    if (status === 'account_exists' || httpStatus === 409) return { ok: false, kind: 'exists', message: 'Esiste già un account con questa e-mail: accedi per continuare.' };
    if (status === 'minor_requires_full_registration') return { ok: false, kind: 'minor', message: 'Per i minorenni serve la registrazione completa con i dati del tutore.' };
    if (status === 'rate_limited' || httpStatus === 429) return { ok: false, kind: 'rate', message: 'Troppi tentativi: riprova tra qualche minuto.' };
    if (status === 'invalid_tax_code') return { ok: false, kind: 'invalid', message: 'Il codice fiscale non è valido.' };
    if (status === 'birth_data_required') return { ok: false, kind: 'invalid', message: 'Per un codice fiscale estero servono genere e data di nascita.' };
    if (status === 'terms_required') return { ok: false, kind: 'invalid', message: 'Accetta i termini per continuare.' };
    return { ok: false, kind: 'error', message: 'Non è stato possibile completare la richiesta. Riprova.' };
}
